import styled from 'styled-components';

export const AcademyPageContainer = styled.div`
  background-color: #d4af37;
  color: #000000;
`;

export const Section = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 16px;
  font-size: 1.6rem;
`;

export const TextBlock = styled.div`
  font-size: 0.95rem;
  line-height: 1.6;
`;

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const ImageBlock = styled.div`
  display: flex;
  justify-content: center;
`;

export const ProgramsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ProgramCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 0.9rem;
  background-color: #ffffff;
`;

export const ProgramImageWrapper = styled.div`
  margin-bottom: 8px;
`;

export const ProgramTitle = styled.h3`
  margin: 0 0 4px;
  font-size: 1rem;
`;

export const ProgramDescription = styled.div`
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const FacilitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FacilityCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 0.9rem;
`;

export const FacilityTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const FacilityDescription = styled.div`
  font-size: 0.85rem;
`;
